let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("jEMvA")]).then(() => parcelRequire('6C8aj'));